import { useTranslation } from 'react-i18next';
import { Camera, LayoutGrid } from 'lucide-react';
import { cn } from '@easymoving/ui';

export type AddMode = 'icons' | 'photos';

/** Segmented control choosing how to add items: icon picker or photo capture. */
export function AddModeTabs({
  mode,
  onChange,
}: {
  mode: AddMode;
  onChange: (mode: AddMode) => void;
}) {
  const { t } = useTranslation();
  const tabs: { key: AddMode; label: string; icon: typeof Camera }[] = [
    { key: 'icons', label: t('capture.iconTab'), icon: LayoutGrid },
    { key: 'photos', label: t('capture.photoTab'), icon: Camera },
  ];
  return (
    <div role="tablist" className="grid grid-cols-2 gap-1 p-1 rounded-xl bg-surface-tint mb-4">
      {tabs.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={mode === key}
          onClick={() => onChange(key)}
          className={cn(
            'flex items-center justify-center gap-2 rounded-lg py-2.5 text-[14px] font-medium transition-colors',
            mode === key ? 'bg-surface text-ink shadow-card' : 'text-graphite hover:text-ink',
          )}
        >
          <Icon className="size-4" />
          {label}
        </button>
      ))}
    </div>
  );
}
